import * as types from './mutationTypes'

const mutations = {
    [types.SET_USERINFO] (state, userInfo) {
        state.userInfo = userInfo
    },
    [types.SET_USERID] (state, userId) {
        state.userId = userId
    },
    [types.SET_OPENID] (state, openId) {
        state.openId = openId
    },
    [types.SET_LOGIN_STATUS] (state, loginStatus) {
        state.loginStatus = loginStatus
    },
    [types.SET_TOKEN] (state, token) {
        state.token = token
    },
    [types.SEND_DICTIONARY] (state, data) {
        state.dictionary = data
    },
    [types.SET_SHOWLEFTSTATUS] (state, data) {
        state.showLeftStatus = data;
    }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js